const darkTheme = {
  textColor: "#000000",
  bgColor: "#FFFFFF",
  actionColor: "#15E0FB"
};
const presets = {
  darkTheme
};

export { presets as default };
//# sourceMappingURL=presets.js.map
